<template>
    <v-container class="ml-10 mr-0 pl-10">
        <v-row>
            <!-- Filter-->
            <v-col sm="3" lg="3" class="ml-0 hidden-sm-and-down">
                <Filtros @change="updateFilter" />
            </v-col>
            <!-- Products-->
            <v-col cols="9">
                <v-row>
                    <!-- Buscador-->
                    <v-text-field
                        v-model="search"
                        single-line
                        class="mx-2"
                        append-icon="search"
                        label="Buscar"
                        @click:append="buscar()"
                        @keyup.enter="buscar()"
                    />
                </v-row>
                <v-row>
                    <v-col
                        v-for="product in (sales ? ofertas:products)"
                        :key="product.id"
                        xs="9"
                        sm="6"
                        md="6"
                        lg="4"
                        class="ml-0 pl-4 py-6"
                    >
                        <p v-if="error" v-text="error" />
                        <ItemProduct :product="product" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!--Paginacion -->
        <v-layout ml-3 my-3 justify-center align-center text-center>
            <v-flex lg6 xl6>
                <v-btn text secondary :disabled="page === 1" @click="prev">
                    Anterior
                </v-btn>
                <v-btn
                    text
                    secondary
                    :disabled="
                        sales
                            ? ofertas.length < productsPerPage
                            : products.length < productsPerPage
                    "
                    @click="next"
                >
                    Siguiente
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ItemProduct from '../components/ItemProduct';
import Filtros from '../components/Filtros';

export default {
    components: { ItemProduct, Filtros },
    props: {
        sales: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        error: '',
        page: 1,
        productsPerPage: 12,
        search: '',
        selectedLabs: []
    }),
    computed: {
        ...mapState('products', ['products', 'ofertas'])
    },
    watch: {
        sales() {
            this.page = 1;
            this.search = '';
            this.updateProducts();
        }
    },

    mounted() {
        this.updateProducts();
    },

    methods: {
        ...mapActions('products', ['getProducts']),
        buscar() {
            this.page = 1;
            this.updateProducts();
        },

        updateFilter(selectedLabs) {
            this.page = 1;
            this.selectedLabs = selectedLabs;
            this.page = 1;
            this.updateProducts();
        },

        updateProducts() {
            this.getProducts({
                search: this.search,
                page: this.page,
                productsPerPage: this.productsPerPage,
                labs: this.selectedLabs,
                sales: this.sales
            });
        },

        prev() {
            if (this.page !== 1) {
                this.page--;
                this.updateProducts();
            }
        },

        next() {
            this.page++;
            this.updateProducts();
        }
    }
};
</script>
